import { styled } from '@mui/material/styles';
import AddTocart from "./AddTocart";
import VerifyCourses from "./VerifyCourses";
import MakePayment from "./MakePayment";
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import { Stepper, Step, StepLabel, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import AppleIcon from '@mui/icons-material/Apple';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { larger } from 'mathjs';
import RadioButtonCheckedTwoToneIcon from '@mui/icons-material/RadioButtonCheckedTwoTone';
import data from "../../../Media/Shopping Card.png"
import data1 from "../../../Media/Verify Courses.png"
import data11 from "../../../Media/Verify Courses1.png"
import data12 from "../../../Media/Make a Payment.png"
import data22 from "../../../Media/Make a Payment1.png"

export default function TrainingAddToCart() {
  const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: 'calc(-50% + 16px)',
      right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#2A93DB',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#2A93DB',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderTopWidth: 3,
      borderRadius: 1,
    },
  }));

  const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
      color: '#2A93DB',
    }),
    '& .QontoStepIcon-completedIcon': {
      color: '#2A93DB',

      fontSize: "30px",
    },
    '& .QontoStepIcon-circle': {
      color: 'currentColor',
      fontSize: "30px",

    },
  }));

  function QontoStepIcon(props) {
    const { active, completed, className } = props;

    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        {completed ? (
          <CheckCircleIcon className="QontoStepIcon-completedIcon" />
        ) : (

          <RadioButtonCheckedTwoToneIcon className="QontoStepIcon-circle" />
        )}
      </QontoStepIconRoot>
    );
  }
  const params = window.location.pathname




  const [activeStep, setActiveStep] = useState(0);

  const [makepayment, setMakePayment] = useState([]);
  useEffect(() => {

    setActiveStep(params == "/AddToCart" ? 1 : 0);

  }, [params]);

  const steps = ['Add Сourses to Сart', '	My Cart - verify courses', 'Make a Payment'];


  const handleNext = (e) => {
    setActiveStep(e);

  };

  const handlemakepayment = (e) => {
    setMakePayment(e);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };
  const handlestep = (e) => {

    if (e == 0) {

      setActiveStep(e);
    }
    else if (e == 1) {
      setActiveStep(e)
    }

  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return <AddTocart activestep={handleNext} />;
      case 1:
        return <VerifyCourses activestep={handleNext} dataset={handlemakepayment} />;
      case 2:
        return <MakePayment Payflow={makepayment} />;

      default:
        return 'Unknown step';
    }
  };

  return (
    <div>
      <Box border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec"
        sx={{
          background: "#fff",
          paddingTop: "10px",
          paddingBottom: "10px",
          marginBottom: "20px",
          padding: "10px",
          marginTop:"20px"
        }}>
        <Stepper
          activeStep={activeStep} alternativeLabel
           style={{ marginTop: "85px", marginBottom: "1px",    width: "126%", left: "-174px",   position: "relative" }}
           sx={{
            width: '126%',
            position: 'relative',
            marginTop: "85px",
            marginBottom: "85px",
            left: {
              xs: '0px', // for extra-small screens
              sm: '-50px', // for small screens
              md: '-100px', // for medium screens
              lg: '-174px', // for large screens and up
            },
          }}
            connector={<QontoConnector />}>
          {steps?.map((label, index) => (
            <Step key={label} onClick={() => handlestep(index)} style={{ cursor: steps[0] ? "pointer" : "default" || steps[1] ? "pointer" : "default" }}>
              <StepLabel StepIconComponent={QontoStepIcon}>
                <div style={{ marginTop: "-123px", }}>
                  {index === 0 &&
                    <div style={{ textAlign: 'center' }} >  <div style={{

                      background: index === activeStep || (activeStep == 1 || 2) ? '#DEEDF7' : '#F2F4F7',
                      borderRadius: '100px',
                      position: 'relative',
                      margin: '0 auto', // Center horizontally
                      display: 'flex', // Enable flex container
                      width: "64px",
                      height: "64px",
                      justifyContent: 'center', // Center horizontally
                      alignItems: 'center', // Center vertically
                    }}> <img src={data} /></div></div>}
                  {index === 1 &&
                    <div style={{ textAlign: 'center' }} >  <div style={{

                      background: index === activeStep || (activeStep == 2) ? '#DEEDF7' : '#F2F4F7',
                      borderRadius: '100px',
                      position: 'relative',
                      margin: '0 auto', // Center horizontally
                      display: 'flex', // Enable flex container
                      width: "64px",
                      height: "64px",
                      justifyContent: 'center', // Center horizontally
                      alignItems: 'center', // Center vertically
                    }}>
                      {(index === activeStep || (activeStep == 2)) ? <img src={data11} /> : <img src={data1} />

                      }

                    </div></div>}
                  {index === 2 &&
                    <div style={{ textAlign: 'center' }} >  <div style={{

                      background: index === activeStep ? '#DEEDF7' : '#F2F4F7',
                      borderRadius: '100px',
                      position: 'relative',
                      margin: '0 auto', // Center horizontally
                      display: 'flex', // Enable flex container
                      width: "64px",
                      height: "64px",
                      justifyContent: 'center', // Center horizontally
                      alignItems: 'center', // Center vertically
                    }}>
                      {(index === activeStep) ? <img src={data22} /> : <img src={data12} />}
                    </div></div>}


                </div>

                <div style={{ marginTop: "55px" }}>
                  {label}
                </div>
              </StepLabel>

            </Step>
          ))}

        </Stepper>
      </Box>

      <div>
        {activeStep === steps?.length ? (
          <div>
            <p>All steps completed</p>
          </div>
        ) : (
          <div>
            {getStepContent(activeStep)}
            {/* <Button disabled={activeStep === 0} onClick={handleBack}>
              Back
            </Button>
            <Button variant="contained" color="primary" onClick={handleNext}>
              {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
            </Button> */}
          </div>
        )}
      </div>
    </div>
  )

}